import * as React from "react";
import { useCallback } from "react";
import styled, { css } from "styled-components";
import { Formik, Form, Field } from "formik";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { Button, FormGroup, InputGroup, FormControl, HelpBlock } from "components/bootstrap";
import ColorPickerPopover from "components/common/ColorPickerPopover";
import Icon from "components/common/Icon";
import { getValueFromInput } from "util/FormsUtils";
import usePermissions from "hooks/usePermissions";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
const ColorPickerPreview = styled.span(
  ({ color }) => css`
    background-color: ${color};
    width: 10px;
    height: 10px;
    display: inherit;
    margin-right: 5px;
    margin-top: 3px;
  `
);
const DEFAULT = {
  badge_enable: false,
  badge_color: "#689f38",
  badge_text: ""
};
const HeaderBadgeConfiguration = ({ config = DEFAULT, updateConfig = () => {
} }) => {
  const { isPermitted } = usePermissions();
  const sendTelemetry = useSendTelemetry("event-notification");
  const _saveConfig = useCallback(
    (values) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.HEADER_BADGE_UPDATED, {
        app_pathname: "event-notification"
      });
      updateConfig(values);
    },
    [sendTelemetry, updateConfig]
  );
  const isDisabled = !isPermitted("clusterconfigentry:edit");
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: { ...DEFAULT, ...config }, onSubmit: _saveConfig, enableReinitialize: true }, ({ dirty, handleSubmit, handleChange, values }) => {
    var _a;
    const badgeTextTooLong = ((_a = values.badge_text) == null ? void 0 : _a.length) > 5;
    return /* @__PURE__ */ React.createElement(Form, { onSubmit: handleSubmit }, /* @__PURE__ */ React.createElement(FormGroup, { validationState: badgeTextTooLong ? "warning" : null }, /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(InputGroup.Addon, null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        id: "badge-enable",
        name: "badge_enable",
        "data-testid": "badge-enable",
        checked: values.badge_enable,
        onChange: (e) => {
          handleChange(e);
        },
        disabled: isDisabled
      }
    )), /* @__PURE__ */ React.createElement(Field, { name: "badge_text" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(
      FormControl,
      {
        type: "text",
        id: "badge-text",
        "data-testid": "badge-text",
        name,
        label: "Badge Text",
        value,
        onChange: (e) => onChange({ target: { name, value: getValueFromInput(e.target) } }),
        disabled: isDisabled
      }
    )), /* @__PURE__ */ React.createElement(Field, { name: "badge_color" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(
      ColorPickerPopover,
      {
        id: "badge-color",
        placement: "left",
        color: value,
        triggerNode: /* @__PURE__ */ React.createElement(Button, { disabled: isDisabled }, /* @__PURE__ */ React.createElement(ColorPickerPreview, { color: value }), /* @__PURE__ */ React.createElement(Icon, { name: "colors" }), " Color"),
        onChange: (color, _, hidePopover) => {
          onChange({ target: { name, value: color } });
          hidePopover();
        }
      }
    )))), /* @__PURE__ */ React.createElement(HelpBlock, null, badgeTextTooLong ? "Should be maximum 5 characters long" : "The text of the badge. Not more than five characters recommended."), !isDisabled && /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "info", type: "submit", disabled: !dirty }, "Update Badge")));
  });
};
export default HeaderBadgeConfiguration;
